// Enums für Tischstatus
export enum TableStatus {
  AVAILABLE = 'available',      // Weiß - verfügbar
  COOKING = 'cooking',          // Orange - Küche kocht, Pizzaiolo soll starten
  CONFIRMED = 'confirmed',      // Blau - beide arbeiten
  KITCHEN_READY_PENDING = 'kitchen_ready_pending', // Orange-Grün Animation - Küche fertig, Pizza-Bestätigung fehlt
  PARTIALLY_READY = 'partially_ready', // Blau-Grün Animation - eine Partei fertig, beide bestätigt
  READY = 'ready',             // Grün - bereit zum servieren
  CANCELLED = 'cancelled'       // Rot - storniert, wartet auf Bestätigung
}

// Enum für Benutzerrollen
export enum UserRole {
  KITCHEN = 'kitchen',    // Küche
  PIZZA = 'pizza'        // Pizzaiolo
}

// Interface für einen Tisch
export interface Table {
  id: number;
  number: string;        // Tischnummer (kann custom sein)
  status: TableStatus;
  actions: {
    kitchenStarted: boolean;    // Küche hat gestartet
    pizzaConfirmed: boolean;    // Pizzaiolo hat bestätigt
    kitchenReady: boolean;      // Küche ist bereit
    pizzaReady: boolean;        // Pizza ist bereit
    cancelledBy?: UserRole;     // Wer hat storniert (falls storniert)
  };
  // Detaillierte Timestamps für jede Action
  actionTimestamps: {
    kitchenStarted?: string;    // Wann Küche gestartet hat
    pizzaConfirmed?: string;    // Wann Pizzaiolo bestätigt hat
    kitchenReady?: string;      // Wann Küche fertig wurde
    pizzaReady?: string;        // Wann Pizza fertig wurde
    cancelled?: string;         // Wann storniert wurde
    served?: string;            // Wann serviert wurde (bei Reset)
  };
  lastUpdated: string;    // ISO timestamp
  updatedBy: UserRole;    // Wer hat zuletzt aktualisiert
}

// Interface für den gesamten App-Zustand
export interface AppState {
  tables: Table[];
  totalTables: number;
  lastSync: string;
  version: number;        // Für Konfliktresolution
}

// Interface für Table Actions
export enum TableAction {
  START_COOKING = 'start_cooking',
  CONFIRM_PIZZA = 'confirm_pizza', 
  MARK_READY = 'mark_ready',
  MARK_SERVED = 'mark_served',
  CANCEL = 'cancel',
  CONFIRM_CANCEL = 'confirm_cancel'
}

// Interface für Action Context
export interface ActionContext {
  tableId: number;
  action: TableAction;
  role: UserRole;
  timestamp: string;
}